import { API } from '../api';
import axiosInstance from '../axiosConfig';

export const getAppointmentByLocation = async (id) => {
  const response = await axiosInstance.get(API.APPOINTMENT.GET_APPOINTMENT_BY_LOCATION + id);
  return response?.data?.data;
};
export const getAppointmentByYearMonth = async (yearmonth, id) => {
  const response = await axiosInstance.get(
    API.APPOINTMENT.GET_APPOINTMENT_BY_YEAR_MONTH + yearmonth + '/' + id
  );
  return response?.data?.data;
};

export const changeAppointmentStatus = async (id, status) => {
  const response = await axiosInstance.post(
    `${API.APPOINTMENT.CHANGE_APPOINTMENT_STATUS}${id}/${status}`
  );
  return response;
};
export const deleteAppointment = async (id) => {
  const response = await axiosInstance.delete(`${API.APPOINTMENT.DELETE}${id}`);
  return response;
};

export const cancelAppointment = async (id) => {
  const response = await axiosInstance.get(`${API.APPOINTMENT.CANCEL_APPOINTMENT}${id}`);
  return response?.data?.data;
};
const STATUS_MAP = {
  confirmed: 'Confirmed',
  completed: 'Complete',
  pending: 'Pending',
  'no-show': 'No Show',
  cancelled: 'Cancelled',
  'follow-up': 'Follow Up'
};

export const getSerilizedAppointments = async (locationId, page, perPage, startDate, endDate,status) => {
    // map + transform
 const mappedStatus = status
    ?.map(s => `"${STATUS_MAP[s]}"`) // 👈 wrap each in quotes
    .join(','); // 👈 join with comma
  // convert to comma-separated string
 // console.log(`${API.APPOINTMENT.PAGINATION_APPOINTMENTS}?locationId=${locationId}&page=${page}&perPage=${perPage}&startDate=${startDate}&endDate=${endDate}&status=${statusQuery}`,'-0')
  const response = await axiosInstance.get(
    `${API.APPOINTMENT.PAGINATION_APPOINTMENTS}?locationId=${locationId}&page=${page}&perPage=${perPage}&startDate=${startDate}&endDate=${endDate}&status=[${mappedStatus}]`
  );
  return response;
};

export const getSerilizedAppointmentsSearch = async (body) => {
  const response = await axiosInstance.post(
    `${API.APPOINTMENT.PAGINATION_APPOINTMENTS_SEARCH}`,
    body
  );
  return response;
};

export const getAppointmemntById = async (id) => {
  const response = await axiosInstance.get(`${API.APPOINTMENT.BY_ID}` + id);
  return response;
};

export const bulkUpdateStatus = async (body) => {
  const response = await axiosInstance.patch(`${API.APPOINTMENT.BULK_UPDATE_STATUS}`, body);
  return response;
};

export const getConversationLogs = async (id, locationId) => {
  const response = await axiosInstance.get(
    `${API.APPOINTMENT.CONVERSTAION_LOGS}${id}?locationId=${locationId}`
  );
  return response;
};

export const todayAppointmentData = async (id) => {
  const response = await axiosInstance.get(API.APPOINTMENT.TODAY_APPOINTMENT_DATA + id);
  return response;
};

export const smsAndEmailReport = async (id) => {
  const response = await axiosInstance.get(API.APPOINTMENT.SMS_EMAIL_REPORT + id);
  return response;
};

export const bulkReviewEmail = async (body) => {
  const response = await axiosInstance.patch(`${API.APPOINTMENT.BULK_REVIEW_EMAIL}`, body);
  return response;
};

export const markAppointmentAsPaid = async (body) => {
  const response = await axiosInstance.post(`${API.APPOINTMENT.MARK_APPOINTMENT_AS_PAID}`, body);
  return response;
};

export const appFeeData = async () => {
  const response = await axiosInstance.get(API.APPOINTMENT.APP_FEE_DATA);
  return response;
};

export const deleteGoogleAppointement = async (locationId, appointmentId) => {
  const response = await axiosInstance.delete(
    `${API.APPOINTMENT.DELETE_GOOGLE_APPOINTMENT}${locationId}/${appointmentId}`
  );
  return response;
};

export const blockGoogleEventFromBlocking = async (locationId, appointmentId) => {
  const response = await axiosInstance.get(
    `${API.APPOINTMENT.ALLOW_BLOCKING_GOOGLE_EVENT}${appointmentId}/${locationId}/false`
  );
  return response;
};

export const deleteMicrosoftAppointement = async (
  locationId,
  appointmentId,
  isRecurring,
  startDate,
  endDate
) => {
  const response = await axiosInstance.delete(
    `${API.APPOINTMENT.DELETE_MICROSOFT_APPOINTMENT}${locationId}/${appointmentId}/${isRecurring}/${startDate}/${endDate}`
  );
  return response;
};

export const blockMicrosoftEventFromBlocking = async (locationId, appointmentId) => {
  const response = await axiosInstance.get(
    `${API.APPOINTMENT.ALLOW_BLOCKING_MICROSFT_EVENT}${appointmentId}/${locationId}/false`
  );
  return response;
};
